'use strict';

const { pubdb } = Function('return this')();
const {
    $, window, document, echo, ajax_post, map, trim, next_tick, kb_ev_up_down_enter, ajax_success_next_handler,
    ajax_success_handler,
} = pubdb;
const { setTimeout, fields, location } = window;


// Handle journal data


$(function () {
    var form = $('#main_form');
    var submit = $(':submit', form);

    function success (resp) {
        try {
            ajax_success_next_handler(resp, 'journal');
        } finally {
            submit.attr('disabled', false);
        }
    }

    function error (data, err, xhr) {
        try {
            echo('warn', 'Fehler (' + data.statusText + ') - bitte versuchen Sie es erneut');
        } finally {
            submit.attr('disabled', false);
        }
    }

    function commit () {
        var data = {
            csrf_token: $('#csrf_token', form).val()
        };
        $(fields).each(function (_, elem) {
            elem = elem[0];
            data[elem] = $('#' + elem, form).val();
        });
        ajax_post(form.attr('action'), data, success, error);
    }

    form.submit(function (ev) {
        ev.preventDefault();
        next_tick(commit);
        submit.attr('disabled', true);
    });
});



// Handle impact factors

$(function () {
    function InvalidFormat (s) {
        this.s = s;
    }
    InvalidFormat.prototype = new Error;

    var autocompletions = [
        ['gold', 'green', 'na', '—'],
        ['Verlags-PDF', 'Postprint', 'na', '—'],
        ['ja', 'nein', 'na', '—'],
        ['1', '2', '3', '4', '—'],
    ];

    function save_success (resp) {
        if (ajax_success_handler(resp)) {
            echo('confirm', 'Impact Factors gespeichert')
        }
    }

    function save_error (data, err, xhr) {
        echo('warn', 'Fehler (' + data.statusText + ') - bitte versuchen Sie es erneut');
    }

    function submit () {
        var id = +$('#main_form input[name=id]').val();
        try {
            var years = map(if_tbody.find('tr'), function (tr) {
                var row = map($('td', tr), function (td, i) {
                    var text = trim($(td).text());
                    return text === '—' ? null : text || null;
                });
                return {
                    journal_id:      id,
                    year:           +row[0],
                    impact_factor:  +row[1] || null,
                    impact_factor5: +row[2] || null,
                    open_access:     row[3],
                    archiv:          row[4],
                    embargo:         row[5],
                    quartile:       +row[6] || null,
                };
            });
        } catch (ex) {
            if (ex instanceof InvalidFormat) {
                echo('warn', ex.s);
                return;
            }
            throw ex;
        }

        ajax_post($('#if_form').attr('action'), {
            csrf_token: pubdb.csrf_token,
            id: id,
            years: years
        }, save_success, save_error);
    }

    var if_form = $('#if_form').on('click', 'tfoot tr', function (ev) {
        if_tbody.append(empty_row.clone());
    }).submit(function (ev) {
        ev.preventDefault();
        next_tick(submit);
    });

    var if_tbody = if_form.find('tbody').on('click', 'td', function (ev) {
        var target = $(ev.target);
        if (target.is('td')) {
            next_tick(function () {
                target.find('span').focus();
            });
        }
    }).on('click', 'th a', function (ev) {
        var tr = $(ev.target).parents('tr');
        tr.hide('medium', function () {
            tr.remove();
        });
    }).on('focus', 'td span', function (ev) {
        next_tick(function () {
            document.execCommand('selectAll', false, null);
        });
    }).on('focus blur keydown', 'td+td+td+td span', function (ev) {
        const span = $(ev.target);
        const text = trim(span.text());
        const td = span.parent('td');
        const div = td.find('div');
        const td_index = td.index() - 4;
        const autocompletion = autocompletions[td_index];
        const text_index = autocompletion.indexOf(text);
        const { type } = ev;

        if (type === 'focusin') {
            const new_div = $('<div/>', {
                css: { position: 'relative' },
                append: $('<div/>', {
                    css: {
                        position: 'absolute',
                        zIndex: 2,
                        backgroundColor: 'rgba(239, 239, 255, 0.75)',
                        border: '2px solid #06c',
                        left: '10px',
                        padding: '3px 6px'
                    },
                    append: $('<ul/>', {
                        css: {
                            margin: 0
                        },
                        append: map(autocompletion, function (v, i) {
                            if (i < autocompletion.length - 1) {
                                return $('<li/>', {
                                    text: v,
                                    css: {
                                        fontWeight: v === text ? 'bold' : 'normal'
                                    }
                                })[0];
                            }
                        })
                    })
                })
            });
            if (div.length) {
                div.find('ul').replaceWith(new_div.find('ul'));
            } else {
                td.append(new_div);
            }
        } else if (type === 'focusout') {
            div.remove();
            if (text_index < 0) {
                span.text(autocompletion[autocompletion.length - 1]);
            }
        } else if (type === 'keydown') {
            const up_down_enter = kb_ev_up_down_enter(ev);
            if (!up_down_enter) {
                return;
            }

            ev.preventDefault();
            next_tick(function () {
                if (up_down_enter === 'Enter') {
                    span.blur();
                    if (window.getSelection) {
                        try {
                            window.getSelection().removeAllRanges();
                        } catch (ex) {
                            // void
                        }
                    }
                    if (document.selection) {
                        try {
                            document.selection.empty();
                        } catch (ex) {
                            // void
                        }
                    }
                } else {
                    const { length } = autocompletion;
                    const i = (text_index + (up_down_enter === 'ArrowUp' ? -1 : +1) + length) % length;
                    span.text(autocompletion[i]).trigger('focusin');
                }
            });
        }
    });
    var empty_row = if_tbody.find('tr:first').remove();

    const { hash } = location;
    if (/^(#\w+)$/.exec(hash)) {
        setTimeout(function () {
            const elem = document.querySelector(hash);
            if (elem) {
                elem.focus();
                elem.scrollIntoView(true);
            }
        }, 180);
    }
});
